<div class="social-network-post">
  <h1>{{ "socialNetwork.title" | transloco }}</h1>
  <p class="social-network__subtitle">
    {{ "socialNetwork.subtitle" | transloco }}
  </p>

  <div class="margin-container input--extended">
    <app-upload
      #image
      [label]="'socialNetwork.imageLabel' | transloco"
      [required]="true"
      [placeholder]="'socialNetwork.uploadImagePlaceholder' | transloco"
      (onUpload)="imagePreview.setPreviewImageFromFile($event)"
    ></app-upload>
  </div>

  <div
    [ngClass]="{
      'no-image-uploaded': image.uploadedFile == null,
      'image-uploaded': image.uploadedFile != null
    }"
  >
    <app-upload-preview
      #imagePreview
      [previewTitle]="'socialNetwork.imageTitle' | transloco"
      (onDelete)="image.resetInput(); image.uploadedFile = null"
    ></app-upload-preview>
  </div>

  <app-button
    class="form-submit-btn__container"
    [text]="'socialNetwork.sendSocialNetworkPost' | transloco"
    (click)="sendSocialNetworkRequest()"
  ></app-button>

  <p class="social-network__info">
    {{ "socialNetwork.socialNetworkInfo" | transloco }}
  </p>
</div>
<app-spinner [enableSpinner]="loading"></app-spinner>
